import MUIDataTable from 'mui-datatables';
import React from 'react'
import { useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import Toggle from 'react-toggle';
import { getSafetyList  , updateSafety , DeleteCarSafety} from '../../../actions/homeAction';

const CarModel = () => {

	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(getSafetyList())
	},[])

	const handleStatusChange = (Id,active)=>{
		var data ={
			safetyId: Id,
			active : !active
		}
		dispatch(updateSafety(data))
	}

	const HandleDelete = ( ID )=>{
		if(ID){
		dispatch(DeleteCarSafety(ID))
		}
	}

	const safetyList = useSelector(state => state.home.safetyList)?.response

	console.log("safetyList", safetyList);
  const carModelList = []
  let columns = [];

		columns = [
			{
				name: 'safety',
				label: 'Safety Name',
				options: {
					filter: false,
					sort: true,
				},
			},
			
			{
				name: 'safetyAr',
				label: 'Safety Name Ar',
				options: {
					filter: false,
					sort: true,
				},
			},

			{
				name: 'priority',
				label: 'Priority',
				options: {
					filter: false,
					sort: true,
				},
			},
			
			{
				name: 'active',
				label: 'Status',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (active, tableMeta) => {
						var Id = tableMeta.rowData[2];
						return (
							<Toggle
								id={'status_' + Id}
								defaultChecked={active}
								value={active}
								onChange={()=>handleStatusChange(Id, active)}
							/>
						);
					},
				},
			
			},
			{
				name: 'safetyId',
				label: 'Action',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (safetyId) => {
						return (
							<div>
								<Link to={`/CarDetail/Safety/Update/${safetyId}?`}><FaEdit style={{fontSize: '1.4rem'}} /></Link>
								<span className='delBTN' onClick={()=>HandleDelete(safetyId)}><MdOutlineDeleteOutline style={{fontSize: '1.4rem', marginLeft:"1rem"}} /></span>
							</div>
						);
					},
				},
			},

		];
    
		const options = {
			filter: false,
			viewColumns: false,
			print: false,
			download: false,
			selectableRows: 'none',
			textLabels: {
				body: {
					// noMatch: this.state.isSaving
					// 	? 'Loading data..!'
					// 	: 'Sorry, No Users Found',
					toolTip: 'Sort',
					columnHeaderTooltip: column => `Sort for ${column.label}`,
				},
			},
		};
  return (
    <div className='pcoded-inner-content'>
				<div className='main-body'>
					<div className='page-wrapper'>
						<div className='row'>
							<div className='col-sm-12'>
								<div className='card'>
									<div className='card-header'>
										<Link
											to={`/CarDetail/Safety/Add`}
											className='btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger'
											data-modal='modal-13'>
											{' '}
											<i className='icofont icofont-plus m-r-5'></i>
											Add Safety
										</Link>
									</div>

									<div className='card-block'>
										<div className='dt-responsive table-responsive'>
											{carModelList !== undefined ? (
												<MUIDataTable
													title={`Safety`}
													className='table-responsive'
													data={safetyList}
													columns={columns}
													options={options}
												/>
											) : (
												<h4>Loading...</h4>
											)}
											{/* </MuiThemeProvider> */}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
  )
}

export default CarModel